// Menypunktene i Pulse: én katalog for menyen (Sidebar.jsx) og for
// favorittstjerna ved sidetittelen (DashboardLayout gir den til Menyvalg).
// Flyttet hit fra Sidebar.jsx uendret 18.10.2026, da menyen fikk søk og
// favoritter etter Amo Ctrl. Ikonene står i menyikoner.jsx.

import {
  LocationsIcon,
  SmsIcon,
  ScannerIcon,
  UsersIcon,
  CustomerDashIcon,
  ContractIcon,
  WebhookIcon,
  HomeIcon,
  CreateOrderIcon,
  OrdersIcon,
  AnalyticsIcon,
  VehicleIcon,
  InventoryIcon,
  ReceiptIcon,
  WmsOrderIcon,
  HentingIcon,
  ArticlesIcon,
  HmsOverviewIcon,
  ShieldIcon,
  ForkliftIcon,
  SafetyRoundIcon,
  BillingIcon,
  BalanceIcon,
  ProfitLossIcon,
  FinanceIcon,
  SchedulingIcon,
  SettingsIcon,
  ScreenIcon,
  CrmOverviewIcon,
  CompaniesIcon,
  LeadsIcon,
  QuoteIcon,
  InboxIcon,
  ProspectSearchIcon,
  TransportPriceIcon,
  PriceListIcon,
  ArchiveIcon,
  BookIcon,
  TripletexImportIcon,
  StarIcon,
  DriftIcon,
} from './menyikoner'

// Full meny-katalog. Hver item har en `perm`-nøkkel som må være i
// brukerens effektive permission-set for at lenken skal vises. `/`
// vises alltid (Oversikt er landing page for alle innloggede).
export function getNavSections(role, hasPermission) {
  // Kunde-rollen er streng isolert — ingen andre seksjoner vises
  if (role === 'kunde') {
    return [
      {
        items: [
          { path: '/kunde',       label: 'Dashboard',           icon: CustomerDashIcon, perm: 'kunde.dashboard' },
          { path: '/kunde/ordre', label: 'Ordre & Leveranser', icon: OrdersIcon,       perm: 'kunde.orders' },
          { path: '/kunde/avtaler', label: 'Avtaler',           icon: ContractIcon,     perm: 'kunde.contract' },
          { path: '/kunde/fakturaer', label: 'Mine fakturaer',  icon: BillingIcon,      perm: 'kunde.invoices' },
          { path: '/kunde/priser',    label: 'Priser',          icon: PriceListIcon,    perm: 'kunde.prices' },
          { path: '/kunde/prisoppslag', label: 'Prisoppslag',   icon: TransportPriceIcon, perm: 'kunde.orders' },
        ].filter(it => hasPermission(it.perm)).concat([
          // Ingen egen kunde.*-tillatelse: rollens standardrettigheter ligger
          // i role_permissions, og en ny nøkkel måtte seedes dit. Backend
          // krever uansett kundetilknytning.
          { path: '/kunde/tilbud', label: 'Be om tilbud', icon: QuoteIcon },
        ]),
      },
    ]
  }

  const allSections = [
    {
      label: 'Analyse',
      items: [
        { path: '/',              label: 'Dashboard',     icon: HomeIcon }, // alltid synlig
        { path: '/vehicles',      label: 'Flåte',         icon: VehicleIcon,   perm: 'vehicles.view' },
        { path: '/analytics',     label: 'Analyse',       icon: AnalyticsIcon, perm: 'analytics.view' },
        { path: '/leveringskart', label: 'Leveringskart', icon: LocationsIcon, perm: 'analytics.view' },
        { path: '/inventory',     label: 'Lager & WMS',   icon: InventoryIcon, perm: 'inventory.view' },
      ],
    },
    {
      label: 'Delivery',
      items: [
        { path: '/collixl-orders', label: 'Collixl-ordrer',       icon: OrdersIcon,    perm: 'collixl_orders.view' },
        { path: '/mottak',         label: 'Mottak',               icon: OrdersIcon,    perm: 'collixl_orders.view' },
        { path: '/orders',         label: 'Ordre & Forsendelser', icon: OrdersIcon,    perm: 'orders.view' },
        { path: '/tracking',       label: 'Track & Trace',        icon: LocationsIcon, perm: 'tracking.admin' },
        { path: '/sms',            label: 'SMS-logg',             icon: SmsIcon,       perm: 'tracking.admin' },
        { path: '/surveys',        label: 'Tilbakemeldinger',     icon: StarIcon,      perm: 'surveys.view' },
      ],
    },
    {
      label: 'Operations',
      items: [
        { path: '/wms-orders', label: 'Lagerordre',  icon: WmsOrderIcon,  perm: 'wms_orders.view' },
        { path: '/henting',    label: 'Hentekø',     icon: HentingIcon,   perm: 'henting.view' },
        { path: '/receipts',   label: 'Mottak',      icon: ReceiptIcon,   perm: 'receipts.view' },
        { path: '/articles',   label: 'Artikler',    icon: ArticlesIcon,  perm: 'articles.view' },
        { path: '/locations',  label: 'Lokasjoner',  icon: LocationsIcon, perm: 'locations.view' },
        { path: '/scanner',    label: 'Håndskanner', icon: ScannerIcon,   perm: 'scanner.view' },
      ],
    },
    {
      label: 'Personal',
      items: [
        { path: '/min-side', label: 'Min side', icon: SchedulingIcon, perm: 'vaktplan.read' },
        // Bare for dem som planlegger til de ansatte får «Min vakt».
        { path: '/vaktplan', label: 'Vaktplan', icon: SchedulingIcon, perm: 'vaktplan.write' },
      ],
    },
    {
      label: 'HMS & Kontroll',
      items: [
        { path: '/hms-overview', label: 'Oversikt',      icon: HmsOverviewIcon, perm: 'hms.overview' },
        { path: '/hms',          label: 'Avvik & Skader', icon: ShieldIcon,      perm: 'hms.incidents' },
        { path: '/forklift',     label: 'Truckkontroll',  icon: ForkliftIcon,    perm: 'hms.forklift' },
        { path: '/safety-round', label: 'Vernerunde',     icon: SafetyRoundIcon, perm: 'hms.safety_round' },
      ],
    },
    {
      label: 'Økonomi',
      items: [
        { path: '/finance',     label: 'Oversikt',        icon: FinanceIcon,    perm: 'finance.view' },
        { path: '/profit-loss', label: 'Resultatrapport', icon: ProfitLossIcon, perm: 'finance.profit_loss' },
        { path: '/balance',     label: 'Balanse',         icon: BalanceIcon,    perm: 'finance.balance' },
        { path: '/billing',     label: 'Fakturering',     icon: BillingIcon,    perm: 'billing.view' },
      ],
    },
    {
      label: 'Salg & CRM',
      items: [
        { path: '/crm',                  label: 'Oversikt',         icon: CrmOverviewIcon,    perm: 'crm.view' },
        // Skjemaene fra collixl.no: tilbud, palleplass og jobbsøknader.
        { path: '/innboks',              label: 'Innboks',          icon: InboxIcon,          perm: 'innboks.view' },
        { path: '/customers',            label: 'Kunder',           icon: CompaniesIcon,      perm: 'customers.view' },
        { path: '/crm/companies',        label: 'Prospekter (CRM)', icon: CompaniesIcon,      perm: 'crm.companies' },
        { path: '/crm/leads',            label: 'Leads & Pipeline', icon: LeadsIcon,          perm: 'crm.leads' },
        { path: '/crm/quotes',           label: 'Tilbud',           icon: QuoteIcon,          perm: 'crm.quotes' },
        { path: '/crm/offer-requests',  label: 'Tilbudsforespørsler', icon: InboxIcon,       perm: 'crm.quotes' },
        { path: '/crm/prospect-search',  label: 'Finn bedrifter',   icon: ProspectSearchIcon, perm: 'crm.prospect_search' },
        { path: '/crm/price-list',       label: 'Prisliste',        icon: PriceListIcon,      perm: 'crm.price_list' },
        { path: '/crm/transportpriser',  label: 'Transportpriser',  icon: TransportPriceIcon, perm: 'crm.transport_prices' },
      ],
    },
    {
      label: 'Administrasjon',
      items: [
        { path: '/settings',                label: 'Innstillinger',     icon: SettingsIcon,    perm: 'admin.settings' },
        { path: '/drift',                   label: 'Drift og backup',   icon: DriftIcon,       perm: 'admin.settings' },
        { path: '/settings/document-parsers', label: 'Tolkere (parsere)', icon: BookIcon,        perm: 'admin.settings' },
        { path: '/settings/return-sync',    label: 'Shopify retursynk', icon: WebhookIcon,      perm: 'admin.settings' },
        { path: '/liability-waivers',       label: 'Ansvarserklæringer', icon: ShieldIcon,     perm: 'admin.liability_waivers' },
        { path: '/create-order',            label: 'Dokumenttolker',    icon: CreateOrderIcon, perm: 'admin.create_order' },
        { path: '/tripletex-import', label: 'Tripletex-import', icon: TripletexImportIcon, perm: 'admin.tripletex_import' },
        { path: '/documents',    label: 'Dokumentarkiv',    icon: ArchiveIcon,     perm: 'admin.documents' },
        { path: '/docs',         label: 'Dokumentasjon',    icon: BookIcon,        perm: 'admin.docs' },
        { path: '/users',           label: 'Brukere',           icon: UsersIcon,       perm: 'admin.users' },
        { path: '/settings/roles',  label: 'Roller & tilganger', icon: ShieldIcon,      perm: 'admin.users' },
        { path: '/skjermer',        label: 'Skjermer',          icon: ScreenIcon,      perm: 'admin.screens' },
      ],
    },
    {
      label: 'Meldinger',
      items: [
        { path: '/messages', label: 'Meldinger & Webhooks', icon: WebhookIcon, perm: 'messages.view' },
        { path: '/order-rules', label: 'Ordreregler', icon: WebhookIcon, perm: 'messages.view' },
      ],
    },
  ]

  return allSections
    .map(section => ({
      ...section,
      items: section.items.filter(item => !item.perm || hasPermission(item.perm)),
    }))
    .filter(section => section.items.length > 0)
}
